/**
 * Bottom-nav root routes only (see BottomNavButton / USERS_MAIN_NAV_ITEMS + artist chats tab).
 * Chat threads (`/chats/:id`), board post detail, and artist profile stay normal routed pages.
 */
export type PersistentMainPaneId =
  | 'board'
  | 'guests'
  | 'discover'
  | 'matcher'
  | 'profile'
  | 'chats'

export function persistentMainPaneForPath(pathname: string): PersistentMainPaneId | null {
  if (pathname === '/' || pathname === '/board') return 'board'
  if (pathname === '/guest-artists') return 'guests'
  if (pathname === '/discover') return 'discover'
  if (pathname === '/tattoo-artist-matcher') return 'matcher'
  if (pathname === '/profile') return 'profile'
  if (pathname === '/chats') return 'chats'
  return null
}

export function pathUsesPersistentMainLayer(pathname: string): boolean {
  return persistentMainPaneForPath(pathname) != null
}

/** Avoid resetting window scroll when switching only between those roots. */
export function shouldPreserveScrollBetweenPaths(from: string, to: string): boolean {
  return pathUsesPersistentMainLayer(from) && pathUsesPersistentMainLayer(to)
}
